import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=49719cd0&lang=pug"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=49719cd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports